<script setup lang="ts">
const {
  step,
  min,
  max,
  innerClass = "",
} = defineProps<{
  step?: number;
  min?: number;
  max?: number;
  innerClass?: string;
}>();

const amount = defineModel<number>();

type Slots = {
  prefix(): HTMLElement;
  suffix(): HTMLElement;
};

defineSlots<Slots>();
</script>

<template>
  <FormKit
    v-bind="$attrs"
    v-model="amount"
    number="integer"
    type="number"
    inputmode="numeric"
    :step="step ?? 1"
    :min="min"
    :max="max"
    outer-class="w-full"
    :inner-class="`hide-number-input-arrows ${innerClass}`"
  >
    <template #prefix>
      <slot name="prefix" />
    </template>
    <template #suffix>
      <slot name="suffix" />
    </template>
  </FormKit>
</template>
